import { E as h, u as C, s as N, m, l as x, j as u, P as D, k as T, R as P, N as K, v as U } from "./export-cdcbfb2b.js";
import { f as k } from "./es.object.to-string-f55666a8.js";
import { c as F } from "./classof-21a3574e.js";
var M = {}, G = C.f, L = N, B = h, O = B("toStringTag"), Or = function(r, e, t) {
  r && !t && (r = r.prototype), r && !L(r, O) && G(r, O, { configurable: !0, value: e });
}, q = h, z = M, H = q("iterator"), J = Array.prototype, Q = function(r) {
  return r !== void 0 && (z.Array === r || J[H] === r);
}, V = F, S = m, W = x, X = M, Y = h, Z = Y("iterator"), _ = function(r) {
  if (!W(r))
    return S(r, Z) || S(r, "@@iterator") || X[V(r)];
}, rr = u, tr = D, ar = T, er = P, or = _, nr = TypeError, fr = function(r, e) {
  var t = arguments.length < 2 ? or(r) : e;
  if (tr(t))
    return ar(rr(t, r));
  throw new nr(er(r) + " is not iterable");
}, sr = u, p = T, vr = m, ir = function(r, e, t) {
  var o, s;
  p(r);
  try {
    if (o = vr(r, "return"), !o) {
      if (e === "throw")
        throw t;
      return t;
    }
    o = sr(o, r);
  } catch (v) {
    s = !0, o = v;
  }
  if (e === "throw")
    throw t;
  if (s)
    throw o;
  return p(o), t;
}, lr = k, yr = u, cr = T, hr = P, ur = Q, Tr = K, g = U, $r = fr, wr = _, A = ir, Ir = TypeError, c = function(r, e) {
  this.stopped = r, this.result = e;
}, b = c.prototype, Sr = function(r, e, t) {
  var o = t && t.that, s = !!(t && t.AS_ENTRIES), v = !!(t && t.IS_RECORD), j = !!(t && t.IS_ITERATOR), $ = !!(t && t.INTERRUPTED), i = lr(e, o), f, l, y, w, n, I, R, d = function(a) {
    return f && A(f, "normal", a), new c(!0, a);
  }, E = function(a) {
    return s ? (cr(a), $ ? i(a[0], a[1], d) : i(a[0], a[1])) : $ ? i(a, d) : i(a);
  };
  if (v)
    f = r.iterator;
  else if (j)
    f = r;
  else {
    if (l = wr(r), !l)
      throw new Ir(hr(r) + " is not iterable");
    if (ur(l)) {
      for (y = 0, w = Tr(r); w > y; y++)
        if (n = E(r[y]), n && g(b, n))
          return n;
      return new c(!1);
    }
    f = $r(r, l);
  }
  for (I = v ? r.next : f.next; !(R = yr(I, f)).done; ) {
    try {
      n = E(R.value);
    } catch (a) {
      A(f, "throw", a);
    }
    if (typeof n == "object" && n && g(b, n))
      return n;
  }
  return new c(!1);
};
export {
  Q as a,
  _ as b,
  M as c,
  Sr as d,
  fr as g,
  ir as i,
  Or as s
};
